import { FC } from 'react'
import cx from 'classnames'

import { ActionButtonProps } from '../ActionButton'

import * as SC from './styled'
import { BannerTitleTextButtonVariant } from './styled'

export type BannerTitleTextButtonProps = {
  className?: string
  title: string
  text: string
  id?: string
  button?: ActionButtonProps
  variant?: BannerTitleTextButtonVariant
}

const BannerTitleTextButton: FC<BannerTitleTextButtonProps> = ({
  className,
  title,
  text,
  button,
  variant,
  id,
}) => {
  return (
    <SC.BannerTitleTextButton
      className={cx('BannerTitleTextButton', className)}
      $variant={variant}
      id={id}
    >
      <SC.Wrapper>
        <SC.Title>{title}</SC.Title>
        <SC.Text>{text}</SC.Text>
      </SC.Wrapper>
      {button && <SC.Button {...button} />}
    </SC.BannerTitleTextButton>
  )
}

export default BannerTitleTextButton
